export default {
  SET_ACCOUNT (state, account) {
    state.account = account
  },
  SET_STATION (state, station) {
    state.station = station
  }
}
